import PropTypes from "prop-types";
import MDBox from "theme/components/MDBox";

import { usePlacesWidget } from "react-google-autocomplete";
import { TextField } from "@mui/material";
import AppConfig from "appConfig";

function GoogleAddressField({ displayName, setAddress, setLatitude, setLongitude }) {
  const { ref } = usePlacesWidget({
    apiKey: AppConfig.google_map_key,
    onPlaceSelected: (place) => {
      // console.log(place);
      setAddress(place.formatted_address);
      setLatitude(place.geometry.location.lat());
      setLongitude(place.geometry.location.lng());
    },
    options: {
      // types: ["(regions)"],
      types: ["address"],
      // componentRestrictions: { country: "ng" },
    },
  });

  // console.log(options);
  return (
    <TextField
      // ref={ref}
      inputRef={ref}
      margin="dense"
      label={displayName}
      type="text"
      fullWidth
      variant="outlined"
    />
  );
}

// Typechecking props of the Transaction
GoogleAddressField.propTypes = {
  displayName: PropTypes.string.isRequired,
  setAddress: PropTypes.func,
  setLatitude: PropTypes.func,
  setLongitude: PropTypes.func,
};

GoogleAddressField.defaultProps = {
  setAddress: null,
  setLatitude: null,
  setLongitude: null,
};

export default GoogleAddressField;
